import api from '@/lib/api';
import type { Product, Category, Customer, Sale, DailySummary, Receipt } from '@/types/pos';

export const posService = {
  getProductByBarcode: async (barcode: string): Promise<Product | null> => {
    try {
      const { data } = await api.get(`/products/barcode/${encodeURIComponent(barcode)}`);
      return data;
    } catch {
      return null;
    }
  },

  getProducts: async (search?: string, categoryId?: string, priceTierId?: string, locationId?: string): Promise<Product[]> => {
    const params = new URLSearchParams();
    if (search) params.set('search', search);
    if (categoryId) params.set('categoryId', categoryId);
    if (priceTierId) params.set('priceTierId', priceTierId);
    if (locationId) params.set('locationId', locationId);
    const { data } = await api.get(`/products/pos?${params}`);
    return Array.isArray(data) ? data : (data?.data ?? []);
  },

  getTopVelocityProducts: async (locationId?: string, priceTierId?: string, limit = 20): Promise<Product[]> => {
    const params = new URLSearchParams();
    if (locationId) params.set('locationId', locationId);
    if (priceTierId) params.set('priceTierId', priceTierId);
    params.set('limit', String(limit));
    const { data } = await api.get(`/products/top-velocity?${params}`);
    return Array.isArray(data) ? data : (data?.data ?? []);
  },

  getCategories: async (): Promise<Category[]> => {
    const { data } = await api.get('/categories');
    return data;
  },

  searchCustomers: async (query: string): Promise<Customer[]> => {
    const { data } = await api.get(`/customers/search?q=${encodeURIComponent(query)}`);
    return data;
  },

  createSale: async (saleData: Record<string, unknown>): Promise<Sale> => {
    const { data } = await api.post('/sales', saleData);
    return data;
  },

  getReceipt: async (saleId: string): Promise<Receipt> => {
    const { data } = await api.get(`/sales/${saleId}/receipt`);
    return data;
  },

  getDailySummary: async (date?: string): Promise<DailySummary> => {
    const params = date ? `?date=${date}` : '';
    const { data } = await api.get(`/sales/daily-summary${params}`);
    return data;
  },
};
